import { useEffect, useState } from "react";
import { packages as packagesService } from "../../../api/packages.service";

type PackageOption = {
  value: string;
  label: string;
};

export function usePackageOptions() {
  const [packageOptions, setPackageOptions] = useState<PackageOption[]>([
    { value: "", label: "Select a package..." },
  ]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchPackages = async () => {
      setIsLoading(true);
      try {
        const response = await packagesService.getAll({ isActive: true });
        setPackageOptions([
          { value: "", label: "Select a package..." },
          ...response.packages.map(pkg => ({
            value: pkg.id,
            label: `${pkg.name} (${pkg.productCode} v${pkg.version})`,
          })),
        ]);
      } catch (err) {
        console.error("Failed to fetch packages:", err);
        setError(err instanceof Error ? err : new Error("Failed to fetch packages"));
      } finally {
        setIsLoading(false);
      }
    };

    fetchPackages();
  }, []);

  return { packageOptions, isLoading, error };
}
